import React from 'react'

import { Dashboard, DashboardBackButton, PageLayout } from '@components'
import { HeadContent, Subsection } from '@fourthwall/components'
import { useCreatorIntegrationsV2Query } from '@queries'
import { routing } from '@utils/routing'

import bookfunnelSignet from '../../assets/signets/bookfunnel.svg'
import { ConnectBar } from '../../components/ConnectBar/ConnectBar'
import { isAppConnected } from '../../utils/isAppConnected'
import { mapStatusToTagProps } from '../../utils/mapStatusToTagProps'

export const AppsBookfunnel = () => {
  const { creatorIntegrationsV2Query } = useCreatorIntegrationsV2Query()

  const findApp = (
    app: NonNullable<typeof creatorIntegrationsV2Query.data>['apps'][number]['app'],
  ) => {
    return creatorIntegrationsV2Query.data?.apps.find((item) => item.app === app)
  }

  const bookfunnelApp = findApp('BOOKFUNNEL')
  const isConnected = isAppConnected(bookfunnelApp?.status)
  const tag = mapStatusToTagProps(bookfunnelApp?.status, false)

  return (
    <>
      <HeadContent title="BookFunnel" />
      <PageLayout size="tiny">
        <Dashboard.Section
          name="BookFunnel"
          topContent={<DashboardBackButton label="Apps" to={routing.apps.self} />}
        >
          <Subsection>
            <ConnectBar
              logoSrc={bookfunnelSignet}
              tag={tag}
              description={isConnected ? `Connected to BookFunnel` : `Connect to BookFunnel`}
              info={
                isConnected ? (
                  <p>Use BookFunnel to deliver e-books for orders sold on Fourthwall.</p>
                ) : (
                  <p>
                    Connect your BookFunnel account to automatically deliver e-books to your
                    customers.
                  </p>
                )
              }
              connectButtonLabel="How to Connect"
              onConnect={
                isConnected
                  ? undefined
                  : () => {
                      window.open(routing.external.bookfunnel.docs, '_blank')
                    }
              }
            />
          </Subsection>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
